import React, { useState, useEffect } from 'react'
import { Button, Grid } from '@material-ui/core'
import MaterialTable from 'material-table'
import AddIcon from '@material-ui/icons/Add'
import { Modal17 } from '../../Modals/ModalSec1/Modal17'
import { getTechnicalAssistanceReceived } from '../../../../../services/AsistenciaTecnica/get'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import swal from 'sweetalert'
import { deleteTechnicalAssistanceReceived } from '../../../../../services/AsistenciaTecnica/delete'

export const Table17 = (props) => {
  const {
    TechnicalAssistanceReceivedNumber,
    IdTechnicalAssistanceAnswer,
    formik,
  } = props
  const [open, setOpen] = useState(false)
  const [data, setData] = useState([])
  const [disabledButton, setDisabledButton] = useState(false)
  const [body, setBody] = useState({})

  const getTechnicalAssistanceReceivedList = async () => {
    try {
      const response = await getTechnicalAssistanceReceived(
        IdTechnicalAssistanceAnswer,
      )
      if (response.Success) {
        setData(response.Data)

        if (response.Data.length === TechnicalAssistanceReceivedNumber) {
          formik('validateTable17', true)
        } else {
          formik('validateTable17', false)
        }

        if (
          response.Data.length === TechnicalAssistanceReceivedNumber ||
          response.Data.length >= TechnicalAssistanceReceivedNumber
        ) {
          setDisabledButton(true)
        } else {
          setDisabledButton(false)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleDelete = async (id) => {
    try {
      const response = await deleteTechnicalAssistanceReceived(id)

      if (response.Success) {
        swal({
          title: '¡Registro eliminado exitosamente!',
          icon: 'success',
        })
        getTechnicalAssistanceReceivedList()
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (
      IdTechnicalAssistanceAnswer !== '' &&
      IdTechnicalAssistanceAnswer !== null &&
      IdTechnicalAssistanceAnswer !== undefined
    )
      getTechnicalAssistanceReceivedList()
  }, [IdTechnicalAssistanceAnswer, TechnicalAssistanceReceivedNumber])

  const columns = [
    {
      title: 'Título Asistencia Técnica',
      field: 'TechnicalAssistanceTitle',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Ente Financiador',
      field: 'FundingEntity',
      sorting: false,
      filtering: false,
    },
  ]

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={data}
            onSelectionChange={(selectedRows) => console.log(selectedRows)}
            actions={[
              {
                icon: () => (
                  <Button
                    variant="contained"
                    color="success"
                    style={
                      disabledButton
                        ? {}
                        : { backgroundColor: '#27C27D', color: '#FFFFFF' }
                    }
                    startIcon={<AddIcon style={{ color: 'white' }} />}
                    disabled={disabledButton}
                    onClick={() => {
                      setOpen(true)
                    }}
                  >
                    Agregar registro
                  </Button>
                ),
                tooltip: 'Agregar',
                position: 'toolbar',
              },
              {
                icon: () => <EditIcon style={{ color: '#0d53ad' }} />,
                tooltip: 'Editar',
                onClick: (event, rowData) => {
                  setOpen(true)
                  setBody(rowData)
                },
              },
              {
                icon: () => <DeleteIcon style={{ color: 'red' }} />,
                tooltip: 'Eliminar registro',
                onClick: (event, rowData) => {
                  swal({
                    title: '¿Está seguro de eliminar el registro?',
                    icon: 'warning',
                    buttons: ['No', 'Si'],
                    dangerMode: true,
                  }).then(function (isConfirm) {
                    if (isConfirm) {
                      handleDelete(rowData.IdTechnicalAssistanceReceived)
                    }
                  })
                },
              },
            ]}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: true,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',

              exportFileName: 'TableData',
              addRowPosition: 'first',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              toolbarButtonAlignment: 'left',
              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),

              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
            icons={{
              Edit: () => <EditIcon style={{ color: '#0d53ad' }} />,
              Delete: () => <DeleteIcon style={{ color: 'red' }} />,
            }}
          />
        </Grid>
        <Modal17
          open={open}
          setOpen={setOpen}
          getTechnicalAssistanceReceivedList={
            getTechnicalAssistanceReceivedList
          }
          body={body}
          setBody={setBody}
          IdTechnicalAssistanceAnswer={IdTechnicalAssistanceAnswer}
        />
      </Grid>
    </>
  )
}
